export const getSidebarShowDeck = (state) => state.layoutManager.showDeck;

export default { getSidebarShowDeck };
